import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ManageAddresses } from '@components/templates/myAccount';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import { useGetMyAccountAddresses } from '@services/useGetMyAccountAddresses';

export function ManageAddressesPage() {
    const { t } = useTranslation();
    const { addresses, addressesDetail } = useData();
    const { request: requestGetMyAccountAddresses } = useGetMyAccountAddresses();

    const translations = {
        title: t('manage-addresses-component.metatags.title'),
        description: t('manage-addresses-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myAddresses,
        index: false,
    });

    useEffect(() => {
        requestGetMyAccountAddresses();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addressesDetail]);

    const formattedAddresses =
        (addresses?.data || []).map((item) => {
            return {
                uuid: item.uuid || '',
                name: item.name || '',
                lastName: item.lastName || '',
                fiscalNumber: item.fiscalNumber || '',
                type: item.type || '',
                address: item.address || '',
                complement: item.complement || '',
                district: item.district || '',
                municipality: item.municipality || '',
                postalCode: item.postalCode || '',
                region: item.region || '',
                primary: item.primary || '',
            };
        }) ?? [];

    return <ManageAddresses addresses={formattedAddresses} />;
}
